import { render, staticRenderFns } from "./GovernmentReceiptEdit.vue?vue&type=template&id=7f3dc67c&scoped=true&"
import script from "./GovernmentReceiptEdit.vue?vue&type=script&lang=js&"
export * from "./GovernmentReceiptEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3dc67c",
  null
  
)

export default component.exports